<template>
	<div class="getCardSuccess">
		<banner class="steps"></banner>
		<div class="wrap">
			<div class="top">
				<img src="../../static/images/success-icon.png"/>
				<h3>{{$t('getCardSuccess.top.title')}}</h3>
				<div class="topBox">
					<div>
						<p><span>{{$t('getCardSuccess.top.order_id')}}</span>{{order_id}}</p>
						<p><span>{{$t('getCardSuccess.top.freight')}}</span>{{freight}}</p>
					</div>
				</div>
				<div class="tip">
					<p>{{$t('getCardSuccess.top.tip')}}</p>
				</div>
				<!--<div class="attention">
					<img src="../../static/images/code-ct.png"/>
					<div>
						<p v-html="$t('getCardSuccess.attention.tip1')"></p>
						<p v-html="$t('getCardSuccess.attention.tip2')"></p>
					</div>
				</div>-->
				<!--<p style="text-align: right;" class="link"><router-link :to="{name: 'index'}">{{$t('btn.act_back')}}</router-link></p>-->
			</div>
			<div class="choosePkg package">
				<h3 class="title-top" :data-tips="$i18n.locale=='zh'?'限量抢购  学生专属 ':'限量搶購  學生專屬'">{{$t('getCardSuccess.pkg_title')}}</h3>
				<ul class="packageList">
	                <li class="clearfix">
	                    <img class="hot" src="../../static/images/icon-hot.png" alt="">
	                    <div class="title" data-duration="有效期：1年">
	                        <p class="price">HK$<span>{{pkgList[0].price}}</span></p>
	                        <p><s>HK$ {{pkgList[0].oldprice}}</s></p>
	                    </div>
	                    <div class="mid">
	                        <img src="../../static/images/packageIcon-1.png" alt=""><span><i>{{pkgList[0].flow}}GB</i><br/>{{pkgList[0].des[0]}}</span>
	                    </div>
	                    <div class="mid">
	                        <img src="../../static/images/packageIcon-2.png" alt=""><span><i>{{pkgList[0].time_hk}}min</i><br/>{{pkgList[0].des[1]}}</span>
	                    </div>
	                    <div class="mid">
	                        <img src="../../static/images/packageIcon-3.png" alt=""><span><i>{{pkgList[0].time_ch}}min</i><br/>{{pkgList[0].des[2]}}</span>
	                    </div>
	                    <div class="mid">
	                        <a href="javascript:void(0)" class="btn" @click="buyPkg('200000056')">{{$t('btn.order')}}</a>
	                    </div>
	                </li>
	                <li class="clearfix">
	                    <div class="title" data-duration="有效期：1年">
	                        <p class="price">HK$<span>{{pkgList[1].price}}</span></p>
	                        <p><s>HK$ {{pkgList[1].oldprice}}</s></p>
	                    </div>
	                    <div class="mid">
	                        <img src="../../static/images/packageIcon-1.png" alt=""><span><i>{{pkgList[1].flow}}GB</i><br/>{{pkgList[1].des[0]}}</span>
	                    </div>
	                    <div class="mid">
	                        <img src="../../static/images/packageIcon-2.png" alt=""><span><i>{{pkgList[1].time_hk}}min</i><br/>{{pkgList[1].des[1]}}</span>
	                    </div>
	                    <div class="mid">
	                        <img src="../../static/images/packageIcon-3.png" alt=""><span><i>{{pkgList[1].time_ch}}min</i><br/>{{pkgList[1].des[2]}}</span>
	                    </div>
	                    <div class="mid">
	                        <a href="javascript:void(0)" class="btn" @click="buyPkg('200000057')">{{$t('btn.order')}}</a>
	                    </div>
	                </li>
	            </ul>
	            <p class="listTip">{{$t('getCardSuccess.listTip')}}</p>
			</div>
			<rules></rules>
			<!--<a href="javascript:void(0)" @click="buyPkg">{{$t('btn.order')}}</a>-->
		</div>
		<footer>{{$t('footer')}}</footer>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import banner from '@/components/banner'
import rules from '@/components/rules'
export default {
  name: 'getCardSuccess',
  components: { banner,rules },
  data () {
    return {
    	
    }
  },
  computed: {
  	...mapState('param',['gutter']),
  	order_id () {
  		return this.$store.state.param.order_id
  	},
  	freight () {
  		return this.$i18n.locale=='zh'?'免费':'免費'
  	},
  	pkgList () {//套餐详细信息
  		return this.$i18n.locale == 'zh'?require('@/common/json/pkgList'): require('@/common/json/pkgList_hk')
  	},
  },
  methods: {
  	buyPkg (bundlecode) {
  		//存活动标识 online 线上
  		window.sessionStorage.setItem('activeFlag', 'online')
  		this.$router.push({name: 'payConfirm',query: {'bundlecode': bundlecode}})
  	}
  },
  created () {
  	if(window.sessionStorage.getItem('order_id')){
  		this.$store.commit('param/setOrderId', window.sessionStorage.getItem('order_id'))
	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.top{
	text-align: center;
	color: #666;
	h3{
		font-size: 18px;
		font-weight: 400;
		margin: 30px 0 20px;
		line-height: 18px;
	}
	.topBox{
		background-color: #f2f6fa;
		border-radius: 5px;
		padding: 25px 0;
		text-align: center;
		div{
			display: inline-block;
			p{
				text-align: left;
				font-size: 14px;
				line-height: 20px;
			}
		}
	}
	.tip{
		text-align: center;
		box-sizing: border-box;
		padding: 15px 45px 25px;
		/*border-bottom: 1px dashed #dedede;*/
		p{
			text-align: left;
			display: inline-block;
			font-size: 14px;
			line-height: 16px;
		}
	}
	.attention{
		padding-top: 12px;
		text-align: left;
		color: #333;
		line-height: 15px;
		display: flex;
		align-items: center;
		p{
			padding-left: 20px;
			padding-right: 40px;
			margin-bottom: 10px;
		}
		p:last-child{
			margin-bottom: 0px;
		}
	}
	.link{
		margin-top: 18px;
		a{
			color: #54b1ff;
			font-size: 14px;
		}
	}
}
.choosePkg{
	.title-top{
		font-size: 24px;
		color: #333;
		font-weight: 500;
		text-align: center;
		line-height: 24px;
		margin-bottom: 30px;
		position: relative;
		&:after{
			content: attr(data-tips);
			font-weight: 700;
			font-size: 16px;
			color: #fff;
			display: inline-block;
			line-height: 30px;
			padding: 0 10px;
			border-radius: 3px;
			background-color: #ef850a;
			position: absolute;
			top: -40px;
			left: 50%;
			transform: translateX(-50%);
		}
		&:before{
			content: "";
			width: 0;
			height: 0;
			border-top: 7px solid #ef850a;
			border-left: 5px solid transparent;
			border-right: 5px solid transparent;
			border-bottom: 7px solid transparent;
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			top: -10px;
		}
	}
}
.package .packageList li:hover .title .price{color: #ef850a;}
footer{
	text-align: center;
	line-height: 55px;
	font-size: 12px;
	color: #999;
}
@media (min-width:768px) {
	.top{
		width: 410px;
		margin: 0 auto;
		padding-bottom: 60px;
	}
	.choosePkg{
		margin-bottom: 45px;
	}
}
@media (max-width:767px) {
	.top{
		padding-bottom: 30px;
	}
	.wrap{
		padding: 0 20px;
	}
	.choosePkg{
		.title-top{
			font-size: 20px;
		}
	} 
}
</style>



// WEBPACK FOOTER //
// src/pages/getCardSuccess.vue